import PropTypes from 'prop-types';

export const menuPropTypes = {
  /**
   * Element to anchor the menu.
   */
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * Controls whether the menu is open or closed.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Function to call when the menu is closed.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Array of menu categories, each containing title, icon, items, and optional subcategories.
   */
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      icon: PropTypes.elementType,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          children: PropTypes.element,
          icon: PropTypes.elementType,
          fontWeight: PropTypes.string,
          pushDown: PropTypes.number,
          link: PropTypes.string,
        }),
      ),
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          icon: PropTypes.elementType,
          items: PropTypes.arrayOf(
            PropTypes.shape({
              label: PropTypes.string,
              children: PropTypes.element,
              icon: PropTypes.elementType,
              fontWeight: PropTypes.string,
              pushDown: PropTypes.number,
              link: PropTypes.string,
            }),
          ),
          pushDown: PropTypes.number,
        }),
      ),
    }),
  ).isRequired,

  /**
   * Number of columns for the grid layout in the menu.
   */
  columns: PropTypes.number,

  /**
   * The background color of the menu.
   * Can be one of 'primary', 'secondary', or a custom color string.
   */
  backgroundColor: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
};

export const menuDefaultProps = {
  backgroundColor: '#EBEEF2',
  columns: 3,
};
